import Cookies from 'universal-cookie';
import { routes } from './routes';

export const passwordRecoverySteps = {
    sendSMSWithCode: 1,
    verifyPhoneNumber: 2,
    setNewPassword: 3,
    completed: 4
}

export const defaultPasswordRecoverySteps = passwordRecoverySteps.sendSMSWithCode;